<style lang="scss" scoped>
.clean-tabs {
  border-radius: 4px;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;

  .first-tab {
    border-top-left-radius: 4px !important;
  }

  .tab-search {
    max-width: 300px !important;
    padding: 4px;
    margin-right: 5px;
  }

  .tab-active {
    background-color: rgba(25, 118, 210, 0.15);
  }

  .square-corners {
    border-radius: 0px !important;
  }

  &.square-corners {
    border-radius: 0px !important;
  }
}
</style>

<template>
  <v-tabs
    v-model="model"
    :class="['mx-0', 'px-0', 'clean-tabs', squareCorners ? 'square-corners' : '']"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <v-tab
      v-for="(tab, idx) in tabs"
      :key="tab.text"
      :id="`anchor-tab-${idx}`"
      :class="{
        'first-tab': idx === 0,
        'square-corners': squareCorners,
      }"
      :to="tab.to"
      active-class="tab-active"
    >
      {{ tab.text }} <span v-if="tab.count && tab.count >= 0">({{ tab.count }})</span>
    </v-tab>

    <v-spacer v-if="enableSearch" />

    <slot name="extra-items" />

    <v-text-field
      v-if="enableSearch"
      v-model="search"
      :loading="loading"
      flat
      outlined
      hide-details
      dense
      append-icon="mdi-magnify"
      label="Search..."
      class="tab-search"
      id="anchor-tabs-search-input"
      @click:append="$emit('activated', search)"
      @keydown.enter="$emit('activated', search)"
    />
  </v-tabs>
</template>

<script>
export default {
  name: 'AnchorTabs',
  props: {
    value: undefined,
    tabs: Array,
    loading: Boolean,
    enableSearch: Boolean,
    initialSearchText: String,
    squareCorners: Boolean,
  },
  data: () => ({
    model: null,
    search: '',
  }),
  mounted() {
    if (this.value) {
      this.model = this.value;
    }
    if (this.initialSearchText) {
      this.search = this.initialSearchTex;
    }
  },
  watch: {
    model(val) {
      this.$emit('input', val);
    },
    search(val) {
      this.$emit('search', val);
    },
    initialSearchText(val) {
      this.search = val;
    },
  },
};
</script>
